import { NgModule } from '@angular/core';

import { GasDynamicPositioningPopupDirective } from './gas-dynamic-positioning-popup.directive';

const DIRECTIVES = [
  GasDynamicPositioningPopupDirective,
];

@NgModule({
  declarations: [
    DIRECTIVES,
  ],
  exports: [
    DIRECTIVES,
  ],
})
export class GasDynamicPositioningPopupModule {}
